import { createFileRoute } from "@tanstack/react-router";
import { seoFor } from "@/lib/i18n/keywordPools";
import ResponsibleGambling from "@/pages/ResponsibleGambling";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/responsible-gambling")({
  head: () => ({
    meta: [
      { title: "Responsible Gambling | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["responsibleGambling"] }).meta },
      { name: "description", content: "Statlign is for informational purposes only. Learn the warning signs of problem gambling, how to set limits, and where to find free confidential help." },
      { property: "og:title", content: "Responsible Gambling | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Statlign is for informational purposes only. Learn the warning signs of problem gambling, how to set limits, and where to find free confidential help." },
      { name: "twitter:title", content: "Responsible Gambling | Statlign" },
      { name: "twitter:description", content: "Statlign is for informational purposes only. Learn the warning signs of problem gambling, how to set limits, and where to find free confidential help." },
    ],
  }),
  component: () => (
    <MainLayout>
      <ResponsibleGambling />
    </MainLayout>
  ),
});
